import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.map.get-or-insert.js";
import "core-js/modules/es.map.get-or-insert-computed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from 'vuedraggable';
export default {
  name: 'menus_nav_config',
  components: {
    draggable: draggable
  },
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    menuMap: function menuMap() {
      var map = new Map();
      var _walk = function walk(list) {
        list.forEach(function (node) {
          if (node.id) map.set(node.id, node);
          if (node.childrens) _walk(node.childrens);
        });
      };
      _walk(this.menuList);
      return map;
    }
  },
  methods: {
    deleteCategory: function deleteCategory(index) {
      this.value.config.value.splice(index, 1);
    },
    addCategory: function addCategory() {
      if (this.value.config.value.length >= 99) {
        this.$message({
          message: '最多可添加99个分类',
          type: 'error'
        });
        return;
      }
      this.value.config.value.push({
        id: '',
        name: '',
        show: true,
        childrens: []
      });
    },
    changeID: function changeID(item, _ref) {
      var menusid = _ref.menusid;
      var node = this.menuMap.get(menusid);
      var childrens = (node === null || node === void 0 ? void 0 : node.childrens) || [];
      this.$set(item, 'childrens', childrens);
      if (this.value.group === 'category' && this.value.key === 'menus_nav') {
        this.$set(item, 'name', (node === null || node === void 0 ? void 0 : node.name) || '');
      }
    }
  },
  created: function created() {
    this.$set(this.value, 'config', _objectSpread({
      // 新添加组件初始数据 start
      value: [{
        id: '',
        name: '',
        show: true,
        childrens: []
      }],
      margin_top: 15,
      //上边距 - 兼容新老组件 默认预置15px
      z_index: 2
    }, this.value.config));
  }
};